import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=7399cba4&scoped=true&"
import script from "./TabContent.vue?vue&type=script&lang=ts&"
export * from "./TabContent.vue?vue&type=script&lang=ts&"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=7399cba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399cba4",
  null
  
)

component.options.__file = "TabContent.vue"
export default component.exports